<template>
    <div class="col-xl-12">
        <div class="card invoice-container">
            <form @submit.prevent="submitForm">
                <div class="card-header">
                    <h5>İlaç Girişi</h5>
                    <div class="d-flex gap-2">
                        <button type="submit" class="btn btn-light-brand">Kaydet</button>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="px-4 row justify-content-between">
                        <div class="col-xl-3">
                            <div class="form-group mb-3">
                                <label for="InvoiceLabel" class="form-label">Düzenleme Tarihi</label>
                                <input type="text" class="form-control" v-model="medicineTransaction.date"
                                    placeholder="Evrak Tarihi">
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="form-group mb-3">
                                <label for="InvoiceLabel" class="form-label">Etiket</label>
                                <input type="text" class="form-control" v-model="medicineTransaction.transaction_label"
                                    placeholder="Etiket">
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="form-group mb-3">
                                <label for="InvoiceNumber" class="form-label">Numarası</label>
                                <input type="text" class="form-control" v-model="medicineTransaction.transaction_id"
                                    placeholder="Numarası">
                            </div>
                        </div>
                    </div>
                    <hr class="border-dashed">
                    <div class="row px-4 justify-content-between">
                        <div class="col-xl-5 mb-4 mb-sm-0">
                            <div class="mb-4">
                                <h6 class="fw-bold">Kimden / Nereden:</h6>
                                <!-- <span class="fs-12 text-muted">Send an invoice and get paid</span> -->
                            </div>
                            <div class="form-group row mb-3">
                                <label for="InvoiceName" class="col-sm-3 col-form-label">Adı</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="searchQuery0"
                                        @input="fetchResults0" placeholder="Firma / Depo Adı">
                                    <ul v-if="searchResults0.length > 0" class="suggestions0">
                                        <li v-for="invoiceFrom in searchResults0" :key="invoiceFrom.id"
                                            @click="selectFrom(invoiceFrom)">
                                            {{ invoiceFrom.name }} {{ invoiceFrom.type ? invoiceFrom.type : '' }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5">
                            <div class="mb-4">
                                <h6 class="fw-bold">Kime / Nereye:</h6>
                                <!-- <span class="fs-12 text-muted">Send an invoice and get paid</span> -->
                            </div>
                            <div class="form-group row mb-3">
                                <label for="ClientName" class="col-sm-3 col-form-label">Adı</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="searchQuery1"
                                        @input="fetchResults1" placeholder="Firma / Depo Adı">
                                    <ul v-if="searchResults1.length > 0" class="suggestions0">
                                        <li v-for="invoiceTo in searchResults1" :key="invoiceTo.id"
                                            @click="selectTo(invoiceTo)">
                                            {{ invoiceTo.name }} {{ invoiceTo.type ? invoiceTo.type : '' }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="border-dashed">
                    <div class="px-4 clearfix">
                        <div class="mb-4 d-flex align-items-center justify-content-between">
                            <div>
                                <h6 class="fw-bold">Satırlar:</h6>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered overflow-hidden" id="tab_logic">
                                <thead>
                                    <tr class="single-item">
                                        <th class="text-center">#</th>
                                        <th class="text-center wd-450">İlaç</th>
                                        <th class="text-center wd-150">Miktar</th>
                                        <th class="text-center wd-150">Birim</th>
                                        <th class="text-center wd-150">Son Kull. Tar.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr id="addr0"
                                        v-for="(transactionDetail, index) in medicineTransaction.transaction_detail"
                                        :key="transactionDetail.id">
                                        <td class="col-1">
                                            {{ index + 1 }}
                                            <button class="btn btn-sm btn-danger" @click="deleteRow(index)">SİL</button>
                                        </td>
                                        <td>
                                            <select v-model="transactionDetail.medicine" class="form-control"
                                                @change="fetchPackages(transactionDetail.medicine)">
                                                <option v-for="medicine in medicines" :key="medicine" :value="medicine">
                                                    {{ medicine.name }}</option>
                                            </select>
                                        </td>
                                        <td><input type="number" class="form-control" step="1" min="1"
                                                v-model="transactionDetail.entered_quantity">
                                        </td>
                                        <td>
                                            <select class="form-control"
                                                v-model="transactionDetail.medicine_package_id">
                                                <option v-for="pack in MedicinePackages" :key="pack.package_type"
                                                    :value="pack.id">{{
                                                        pack.package_type_display }}</option>
                                            </select>
                                        </td>
                                        <td><input type="text" placeholder="Son Kull Tar." class="form-control"
                                                v-model="transactionDetail.expiration_date">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex justify-content-end gap-2 mt-3">
                            <button @click="addRow()" class="btn btn-sm btn-primary">Satır Ekle</button>
                        </div>
                    </div>
                    <hr class="border-dashed">
                    <div class="px-4 pb-4">
                        <div class="form-group">
                            <label for="InvoiceNote" class="form-label">Açıklama:</label>
                            <input type="text" v-model="medicineTransaction.description" placeholder="Açıklama"
                                class="form-control">
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import Swal from 'sweetalert2';
import MedicinePackage from './MedicinePackage.vue';

export default {
    name: 'MedicineTransaction',
    data() {
        return {
            medicineTransaction: {
                date: "",
                transaction_id: "",
                transaction_label: "",
                from_content_type: 0,
                from_object_id: 0,
                to_content_type: 0,
                to_object_id: 0,
                description: "",
                transaction_detail: [
                    {
                        medicine: 0,
                        entered_quantity: 0,
                        expiration_date: "",
                        medicine_package_id: 0,
                    }
                ]
            },
            searchQuery0: '',
            searchQuery1: '',
            searchResults0: [],
            searchResults1: [],
            debounceTimer: null,
            medicines: [],
            MedicinePackages: [],
            medicineUnitChoices: [],
            packageTypeChoices: [],
        }
    },
    mounted() {
        this.fetchMedicines();
    },
    components: {
        MedicinePackage
    },
    methods: {
        async fetchPackages(medicine) {
            console.log('medicine in fetchPackages', medicine);
            if (!medicine) {
                this.MedicinePackages = [];
                return;
            }
            try {
                const response = await this.$axios.get(`medicine_packages/?medicine=${medicine.id}`);
                this.MedicinePackages = response.data.results;
                console.log('packages in fetchPackages', this.MedicinePackages);
            } catch (error) {
                Swal.fire('Hata!', error, 'error');
            }
            this.MedicinePackages.unshift({ id: null, medicine: medicine.id, package_type: medicine.unit, package_type_display: medicine.unit_display, contains_units: medicine.dose_per_unit })
        },
        deleteRow(index) {
            if (this.medicineTransaction.transaction_detail.length === 1 && index === 0) {
                this.medicineTransaction.transaction_detail[index] = { medicine: 0, quantity: 0, expiration_date: "" };
            } else {
                this.medicineTransaction.transaction_detail.splice(index, 1);
            }
        },
        addRow() {
            this.medicineTransaction.transaction_detail.push({ medicine: 0, quantity: 0, expiration_date: "" });
        },
        async fetchMedicines() {
            try {
                const response = await this.$axios.get(`medicine/`);
                this.medicines = response.data.results;
            } catch (error) {
                Swal.fire('Hata!', error, 'error');
            }
        },
        showTransactions() {
            console.log('transactions', this.medicineTransaction);
        },

        fetchResults0() {
            clearTimeout(this.debounceTimer); // Önceki isteği temizle

            if (this.searchQuery0.length < 2) { // En az 2 harf yazıldığında ara
                this.searchResults0 = [];
                return;
            }
            console.log(this.searchQuery0);
            // API çağrısını geciktirmek için debounce (deneme 500ms)
            this.debounceTimer = setTimeout(async () => {
                try {
                    const response = await this.$axios.get(`supplier/?name=${this.searchQuery0}`);
                    response.data.results.forEach(element => {
                        element.type = ' [Tedarikçi]';
                        this.searchResults0.push(element);
                    });
                    try {
                        const responseShelters = await this.$axios.get(`warehouse/?name=${this.searchQuery0}`);
                        if (responseShelters.data.results) {

                            responseShelters.data.results.forEach(element => {
                                element.type = ' [Depo]';
                                console.log(element);
                                this.searchResults0.push(element)
                            });
                        }
                        console.log(this.searchResults0);
                    } catch (error0) {
                        Swal.fire('Hata!', error0, 'error');
                    }
                } catch (error) {
                    Swal.fire('Hata!', error, 'error');
                }
            }, 500);
        },
        fetchResults1() {
            clearTimeout(this.debounceTimer); // Önceki isteği temizle

            if (this.searchQuery1.length < 2) { // En az 2 harf yazıldığında ara
                this.searchResults1 = [];
                return;
            }
            console.log(this.searchQuery1);
            // API çağrısını geciktirmek için debounce (deneme 500ms)
            this.debounceTimer = setTimeout(async () => {
                try {
                    const response = await this.$axios.get(`supplier/?name=${this.searchQuery1}`);
                    response.data.results.forEach(element => {
                        element.type = ' [Tedarikçi]';
                        this.searchResults1.push(element);
                    });
                    try {
                        const responseShelters = await this.$axios.get(`warehouse/?name=${this.searchQuery1}`);
                        if (responseShelters.data.results) {

                            responseShelters.data.results.forEach(element => {
                                element.type = ' [Depo]';
                                console.log(element);
                                this.searchResults1.push(element)
                            });
                        }
                        console.log(this.searchResults1);
                    } catch (error0) {
                        Swal.fire('Hata!', error0, 'error');
                    }
                } catch (error) {
                    Swal.fire('Hata!', error, 'error');
                }
            }, 500);
        },
        selectFrom(invoiceFrom) {
            console.log('selected', invoiceFrom);
            this.searchQuery0 = invoiceFrom.name;
            this.medicineTransaction.from_content_type = invoiceFrom.content_type;
            this.medicineTransaction.from_object_id = invoiceFrom.id;
            this.searchResults0 = [];
        },
        selectTo(invoiceTo) {
            this.searchQuery1 = invoiceTo.name;
            this.medicineTransaction.to_content_type = invoiceTo.content_type;
            this.medicineTransaction.to_object_id = invoiceTo.id;
            this.searchResults1 = [];
        },
        async submitForm() {
            console.log(JSON.stringify(this.medicineTransaction));

            this.medicineTransaction.transaction_detail.forEach(element => {
                element.medicine = element.medicine.id;
            });
            console.log(JSON.stringify(this.medicineTransaction));
            try {
                const payload = {
                    ...this.medicineTransaction,
                    date: dayjs(this.medicineTransaction.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    transaction_detail: this.medicineTransaction.transaction_detail.map(detail => ({
                        ...detail,
                        expiration_date: detail.expiration_date ? dayjs(detail.expiration_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                    })),
                };
                this.medicineTransaction = payload;
                const response = await this.$axios.post('medicine_transaction/', this.medicineTransaction, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt Tamamlandı', 'success');
            } catch (error) {
                console.log('Hata:', error);
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage, // HTML olarak göster (Satır atlamaları çalışsın)
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        }
    }
}
</script>

<style scoped>
.suggestions0 {
    list-style-type: none;
    padding: 0;
    margin: 5px 0 0;
    border: 1px solid #ccc;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    position: absolute;
    width: 50vw;
    z-index: 100000;
}

.suggestions0 li {
    padding: 10px;
    cursor: pointer;
}

.suggestions0 li:hover {
    background-color: #f0f0f0;
}
</style>